import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { Text, TextVariant } from '@naf/text';
import * as S from './Pickup.styles';

interface PickupProps {
  control: Control<any>;
  defaultValue?: boolean;
}

export const Pickup = ({ control, defaultValue = false }: PickupProps) => (
  <>
    <S.PickupBox>
      <S.PickupBoxContent>
        <S.PickupTitle variant={TextVariant.ArticleTextSubHeader}>Nær Oslo:</S.PickupTitle>
        <Text>Fullfør bestillingen digitalt</Text>
        <Text>Hent på NAF hovedkontor i Oslo sentrum.</Text>
        <Text>Må hentes innen 30 dager.</Text>
      </S.PickupBoxContent>
      <Controller
        name="pickupAtOffice"
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Checkbox
            ref={field.ref}
            name={field.name}
            checked={field.value === true}
            onChange={() => field.onChange(!field.value)}
            onBlur={field.onBlur}
            id="pickupAtOffice"
            label="Jeg ønsker å hente fysisk"
          />
        )}
      />
    </S.PickupBox>
    <S.InfoBox>
      <S.PickupTitle variant={TextVariant.ArticleTextSubHeader}>Resten av landet:</S.PickupTitle>
      <Text>
        Reis til <S.NAFCentersLink to="her-finner-du-naf/naf-senter">et av våre NAF-sentre</S.NAFCentersLink>
      </Text>
      <Text>Ta med passfoto og førerkort.</Text>
    </S.InfoBox>
  </>
);
